import React from 'react';
import ReactDOM from 'react-dom/client';
import './glossy-theme.css';
import App from './App';

// Override toLocaleDateString globally to default to Indian English (DD/MM/YYYY)
const originalToLocaleDateString = Date.prototype.toLocaleDateString;
Date.prototype.toLocaleDateString = function(locale, options) {
  if (locale === undefined) {
    return originalToLocaleDateString.call(this, 'en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  return originalToLocaleDateString.call(this, locale, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
